import Image from 'next/image';
import Link from 'next/link';
import { cx, getDownloadURL } from '@/utils';

import { formatDate } from '@/utils/dateHelpers';
import DownloadFileImage from '@/components/common/Icons/DownloadFileImage';
import FileAttachedFileIcon from '@/components/common/Icons/FileAttachedFileIcon';

type Props = {
  title: string;
  publicationDate: string;
  expeditionDate: string;
  isFullScreen?: boolean;
  image: string | null | undefined;
  downloadLink: string | null | undefined;
};

const CardDownloadParticipateStyleB = ({
  title,
  publicationDate,
  expeditionDate,
  isFullScreen = true,
  image,
  downloadLink,
}: Props) => {
  return (
    <div
      className={cx(
        'flex flex-1 animate-fade-in flex-row items-center rounded-md border-[2px] border-transparent bg-white py-[20px] transition-all hover:border-primary hover:shadow-lg',
        { 'gap-[20px] px-[30px]': isFullScreen },
        { 'gap-[10px] px-[15px]': !isFullScreen }
      )}
    >
      <div className="flex min-w-[35px]">
        {image ? (
          <Image width={35} height={47} src={getDownloadURL(image)} alt={title} />
        ) : (
          <FileAttachedFileIcon width={35} height={47} className="h-[47px] w-[35px] text-primary" />
        )}
      </div>

      <div className="line-clamp-4 flex h-full flex-auto flex-col justify-between gap-3">
        <label className="truncate font-workSans text-[16px] font-medium leading-[19px] text-primary">
          {title}
        </label>
        <div className="flex flex-col font-workSans text-[16px] font-normal leading-[19px] text-silver">
          <label>Publicado: {formatDate(publicationDate, 'DD MMM YYYY hh:mm A')}</label>
          <label>Expedido: {formatDate(expeditionDate, 'DD MMM YYYY hh:mm A')}</label>
        </div>
      </div>
      <div className="flex min-w-[32px]">
        <Link
          className="flex cursor-pointer items-center gap-[10px] text-primary"
          href={downloadLink ? downloadLink : '#'}
          download
        >
          <DownloadFileImage width={32} height={32} className="text-primary" />
        </Link>
      </div>
    </div>
  );
};

export default CardDownloadParticipateStyleB;
